import React, { Component, useLayoutEffect, useState } from "react";
import moment from "moment";
import {
  Show,
  TabbedShowLayout,
  Tab,
  ImageField,
  FileField,
  TextField,
  BooleanField,
  TopToolbar,
  SaveButton,
  RefreshButton,
  ListButton,
  EditButton,
  ReferenceManyField,
  DateField,
  Datagrid,
  ReferenceField,
  SimpleForm,
  Toolbar,
  FormDataConsumer,
  GET_ONE,
  useRecordContext,
} from "react-admin";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import {
  getLocalStorageKey,
  RUN_TIME_API_ENDPOINT,
  CommonHeaderOption,
} from "../common/common";
import Modal from "react-responsive-modal";
import noImage from "./../images/combined-shape.svg";
import Spinner from "../../src/spinner";
import myDataProvider from "../myRestProvider";
import Swal from "sweetalert2";
// const topToolbarStyle = {
//   zIndex: 2,
//   display: "inline-block",
//   float: "right"
// };

const ShowTitle = () => {
  const record = useRecordContext();
  return <span>Record - {record ? `${record.complaint_number}` : ""}</span>;
};

const newTab = (url) => {
  window.open(url, "_blank");
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};

const ResendComplaintTicketButton = () => {
  const record = useRecordContext();
  return (
    <div>
      <button
        className="ds-button"
        // onClick={()=>setModalDupShow(!modalDupShow)}
        onClick={() => {
          Swal.fire({
            text: "Are you sure you want to re-send this complaint?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Yes",
            denyButtonText: "No",
          }).then((result) => {
            if (result.isConfirmed) {
              patchResendComTicket(record);
            } else if (result.isDenied) {
              Swal.fire("Changes are not saved", "", "info");
            }
          });
        }}
      >
        <span>Re-Send Complaint Ticket</span>
      </button>
    </div>
  );
};

const patchResendComTicket = (props) => {
  let dataToSend = {
    complaint_number: props?.complaint_number,
  };

  console.log("duppppppppppppppppppp", dataToSend, props);

  const options = CommonHeaderOption();
  const apiUrl = RUN_TIME_API_ENDPOINT;
  options.method = "PATCH";
  options.body = JSON.stringify(dataToSend);
  fetch(
    `${apiUrl}/resend_sfdc_complaint?complaint_number=${props?.complaint_number}`,
    options
  )
    .then((res) => {
      return res.json();
    })
    .then((json) => {
      if (json) {
        console.log("json reply", json, props);
        // setTimeout(()=>{
        if (json.message == "ERROR") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to process your request at this time. Please try again later.",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        } else {
          Swal.fire({
            html: "Successful",
            icon: "success",
          }).then((result) => {
            window.location.reload();
            // navigate(`/discount_schemes/${json.id}/show`)
          });
        }
      }
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Unable to process your request at this time. Please try again later.",
      }).then((result) => {
        // window.location.reload();
        console.log("eroror", error);
        // navigate(`/discount_schemes/${json.id}/show`)
      });
    });
};

const ShowActions = ({ permissions, basePath, data, resource }) => {
  const sfdcComplaints = getLocalStorageKey("sfdc_complaints");
  let locale = getLocalStorageKey("locale");
  const record = useRecordContext();
  return (
    <TopToolbar>
      {sfdcComplaints && !record?.salesforce_id && (
        <ResendComplaintTicketButton />
      )}
      <ListButton basePath={basePath} />
      {!sfdcComplaints && <EditButton basePath={basePath} record={data} />}
    </TopToolbar>
  );
};

const ShowForm = () => {
  // let fileSizeValidation = false;
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     fileSizeValidation: false,
  //     fileTypeValidation: false,
  //     fileExtensionValidation: false,
  //     open: false,
  //   };
  // }

  // These states are unused...need to remove (By Aniket Raut)

  // const [fileSizeValidation, setFileSizeValidation] = useState(false);
  // const [fileTypeValidation, setFileTypeValidation] = useState(false);
  // const [fileExtensionValidation, setFileExtensionValidation] = useState(false);
  // const [open, setOpen] = useState(false);

  let adminFileAaayCount = [];
  let businessFileAaayCount = [];
  const showReferenceNo = getLocalStorageKey("show_reference_no");

  return (
    <div>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          console.log("formData", formData.created_by_id);
          if (formData) {
            return (
              <div className="record-detail-page">
                <p className="complaint-details-label">Record detail</p>
                <div className="complaint-showpage-container">
                  <div className="complaint-showpage-item">
                    <p>Business Name</p>
                    {formData.business_name}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Business Sap Code</p>
                    {formData.sap_code}
                  </div>
                  {formData.created_by_type === "User" && (
                    <div className="complaint-showpage-item">
                      <p>User Id</p>
                      <ReferenceField
                        label="User name"
                        source="created_by_id"
                        reference="users"
                        link="show"
                        allowEmpty
                      >
                        <TextField source="first_name" />
                      </ReferenceField>
                    </div>
                  )}
                  <div className="complaint-showpage-item">
                    <p>Complaint Type</p>
                    {formData.comp_type}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Complaint Number</p>
                    {formData.complaint_number}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Category Name</p>
                    {formData.complaint_category_name}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Subcategory Name</p>
                    {formData.subcategory_name}
                  </div>
                  {showReferenceNo && showReferenceNo.show && (
                    <div className="complaint-showpage-item">
                      <p>Ref Number</p>
                      {formData.reference_number}
                    </div>
                  )}
                  <div className="complaint-showpage-item">
                    <p>Complaint Status</p>
                    {formData.complaint_status}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Created At</p>
                    {moment(formData.created_at).format(
                      "MM/DD/YYYY, H:mm:ss a"
                    )}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Customer Desc</p>
                    {formData.description}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Customer Service</p>
                    {formData.comment}
                  </div>
                  <div className="complaint-showpage-item">
                    <p>Order Number</p>
                    <ReferenceField
                      label="Order Number"
                      source="sap_digital_orders_id"
                      reference="sap_digital_app_orders"
                      link="show"
                      allowEmpty
                    >
                      <TextField source="order_number" />
                    </ReferenceField>
                  </div>
                </div>

                <div className="complaint-files-onshow">
                  {formData.complaint_files &&
                  formData.complaint_files.length === 0 ? (
                    <div>
                      <div className="complaint-files-label">File Uploaded</div>
                      <p className="no-files-uploaded">No file Uploaded</p>
                    </div>
                  ) : (
                    <div className="complaint-files">
                      <div className="complaint-files-label">File Uploaded</div>
                      <div className="upload-file-section">
                        <div className="files-uploaded">
                          <div className="files-uploaded-section">
                            <p className="uploaded-files-label">
                              Customer Files Uploaded
                            </p>
                            <div className="uploaded-files-container">
                              {formData.complaint_files &&
                                formData.complaint_files
                                  .filter((file) => file.file_url != null)
                                  .map((file) => {
                                    // record.complaint_files && record.complaint_files.map(file => {
                                    console.log(
                                      "files,,,,",
                                      file.principle_type
                                    );

                                    if (file.principle_type === "Business") {
                                      businessFileAaayCount.push(
                                        file.principle_type
                                      );
                                    }

                                    return (
                                      <div
                                        className="complaint-file-content"
                                        onClick={() => {
                                          newTab(file.file_url);
                                        }}
                                      >
                                        {file.principle_type === "Business" && (
                                          <div>
                                            {/* <button onClick={() => { deleteFilePop(file); }}>X</button> */}
                                            {file.file_url_data.file_type ===
                                            "image" ? (
                                              <img
                                                src={file.file_url}
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              />
                                            ) : (
                                              <img
                                                src={noImage}
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              />
                                            )}
                                            <p
                                              title={
                                                file.file_url_data.metadata
                                                  .filename
                                              }
                                            >
                                              {
                                                file.file_url_data.metadata
                                                  .filename
                                              }
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  })}
                              {businessFileAaayCount.length <= 0 && (
                                <p className="no-files-uploaded">
                                  No File Uploaded
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="files-uploaded-section">
                            <p className="uploaded-files-label">
                              Customer Service Files
                            </p>
                            <div className="uploaded-files-container">
                              {
                                //  record.complaint_files && record.complaint_files.map(file => {
                                formData.complaint_files &&
                                  formData.complaint_files
                                    .filter((file) => file.file_url != null)
                                    .map((file) => {
                                      console.log(
                                        "files,,,,",
                                        file.principle_type
                                      );

                                      if (
                                        file.principle_type === "AdminPanelUser"
                                      ) {
                                        adminFileAaayCount.push(
                                          file.principle_type
                                        );
                                      }
                                      return (
                                        <div
                                          className="complaint-file-content"
                                          onClick={() => {
                                            newTab(file.file_url);
                                          }}
                                        >
                                          {file.principle_type ===
                                            "AdminPanelUser" && (
                                            <div>
                                              {file.file_url_data.file_type ===
                                              "image" ? (
                                                <img
                                                  src={file.file_url}
                                                  title={
                                                    file.file_url_data.metadata
                                                      .filename
                                                  }
                                                />
                                              ) : (
                                                <img
                                                  src={noImage}
                                                  title={
                                                    file.file_url_data.metadata
                                                      .filename
                                                  }
                                                />
                                              )}
                                              <p
                                                title={
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              >
                                                {
                                                  file.file_url_data.metadata
                                                    .filename
                                                }
                                              </p>
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })
                              }
                              {adminFileAaayCount.length <= 0 && (
                                <p className="no-files-uploaded">
                                  No File Uploaded
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          }
        }}
      </FormDataConsumer>
    </div>
  );
};

const EditToolbar = (props) => (
  <div></div>
  // <Toolbar {...props} >
  //   <SaveButton />
  // </Toolbar>
);

const ComplaintManagementsShow = (props) => (
  <Show {...props} title={<ShowTitle />} actions={<ShowActions />}>
    <SimpleForm toolbar={<EditToolbar />}>
      <ShowForm />
    </SimpleForm>
  </Show>
);

export default ComplaintManagementsShow;
